import script from "./TenantPackageEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantPackageEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__